import { DYNAMIC_VIEW_DEFAULTS_KEY } from '@konnektu/dynamic/common';
import { MetastoreService } from '@konnektu/metastore';

export function saveDynamicViewDefaults(
  metastore: MetastoreService,
  row: { Id: string } | null,
  text: string
) {
  const value = JSON.stringify(JSON.parse(text));

  return row
    ? metastore.update('UIConfig', { Id: row.Id, Value: value })
    : metastore.insert('UIConfig', {
        Key: DYNAMIC_VIEW_DEFAULTS_KEY,
        Value: value
      });
}
